import { Image } from '@react-three/drei'

export default function Pill({ width, height, ...props }) {
  return (
    <Image
      name="pill"
      renderOrder={10}
      url={'./textures/transparent-white.webp'}
      transparent
      opacity={0.3}
      visible={false}
      radius={0.05}
      {...props}
    >
      <planeGeometry args={[width, height, 20, 20]} />
    </Image>
  )
}
